import './App.css';
import Routes from "./Routes/route";

function App() {
  return (
    <div className="App">
      <div className="App">
      <Routes />
    </div>
    </div>
  );
}

export default App;
